import {
  AvatarsCell,
  BadgesCell,
  ColorTypographyCell,
  DateChipCell,
  MailMenuCell,
  RowCell,
  TabIndexTable,
  WARNING_DAYS,
  formatPercent,
  formattedDate,
  numToPercent,
} from '@centerpiece/components';
import {
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Paper,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  CorporateFareOutlined,
  PersonOutlined,
  Search,
} from '@mui/icons-material';
import { useIndexContext } from 'contexts/index.context';
import moment from 'moment';
import { useMemo, useState, useCallback } from 'react';
import {
  useGetProjectTypesQuery,
  useGetProjectWorkflowsQuery,
  useGetRolesQuery,
  useGetFactorAnalyticsQuery,
  usePatchContactMutation,
} from 'store/api';
import { Contact, ProjectType } from 'store/api/models';
import { numFormatter } from 'utils/index.utils';
import { useAnalyticContext } from 'contexts/analytic.context';

export const FactorAnalysisTable = () => {
  const {
    contactRecord,
    team,
    setTeam,
    individual,
    setIndividual,
    projectType,
    setProjectType,
  } = useAnalyticContext();
  const [view, setView] = useState<'contact' | 'organization' | 'none'>('none');
  const [search, setSearch] = useState<string>('');
  const {
    data: factors = {
      contact: [],
      role: [],
      organization: [],
      workflow: [],
      market_segment: [],
    },
  } = useGetFactorAnalyticsQuery({
    params: {
      team: team?.id,
      individual: individual?.id,
      project_type: projectType.id,
    },
  });
  const { data: workflows = [] } = useGetProjectWorkflowsQuery({
    params: { nested: 'all' },
  });
  const [patchContact, patchContactResult] = usePatchContactMutation();
  const { data: roles = [] } = useGetRolesQuery({});
  const [typeFilter, setTypeFilter] = useState<ProjectType>();

  const tableprops: any = useMemo(
    () => ({
      // filters: [
      //   {
      //     options: project_types,
      //     label: 'Project Types',
      //     defaultOption: typeFilter,
      //     onChange: (event: any, newValue: any) => setTypeFilter(newValue),
      //     // loading: projectListFetching,
      //   },
      // ],
      // onRowClick: (event: any, row: any) => navigate(`project/${row.id}`),
      // isLoading: projectListLoading,
      defaultOrder: 'desc',
      defaultOrderBy: 'rev.sort',
      // hoverCell: true,
      headCells: [
        // {
        //   name: 'icon',
        //   icon: true,
        //   label: 'Class',
        // },
        {
          name: 'name',
          label: 'Name',
          textFilter: 'name.text',
          sort: 'name.text',
          component: ColorTypographyCell,
        },
        {
          name: 'role',
          label: 'Role',
          checkboxFilter: 'role.text',
          sort: 'role.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'num',
          label: '# of Projects',
          sort: 'num.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'rev',
          label: '$ Amount',
          sort: 'rev.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'avg',
          label: 'Average Price',
          sort: 'avg.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'win_rate',
          label: 'Win Rate %',
          sort: 'win_rate.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'avg_won_margin',
          label: 'Avg Won Margin',
          sort: 'avg_won_margin.sort',
          component: ColorTypographyCell,
        },
        {
          name: 'avg_lost_margin',
          label: 'Avg Lost Margin',
          sort: 'avg_lost_margin.sort',
          component: ColorTypographyCell,
        },
      ],
    }),
    []
  );
  return (
    <Paper elevation={5} sx={{ p: 2 }}>
      <Grid
        container
        alignItems="center"
        justifyContent={'space-between'}
        sx={{
          p: 1,
        }}
      >
        <Grid item>
          <Typography variant="h6" component={'span'} sx={{ color: 'black' }}>
            {view === 'contact' ? (
              <span>
                Factor Analysis{' '}
                <small>
                  <i>(Grouped by Individual)</i>
                </small>
              </span>
            ) : view === 'organization' ? (
              <span>
                Factor Analysis{' '}
                <small>
                  <i>(Grouped by Organization)</i>
                </small>
              </span>
            ) : (
              'Factor Analysis'
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Grid
            container
            alignItems={'bottom'}
            justifyContent={'flex-end'}
            spacing={2}
          >
            {/* <Grid item>
              <ToggleButtonGroup
                value={view}
                exclusive
                onChange={(event: any, value: any) => setView(value)}
              >
                <ToggleButton value="contact">
                  <Tooltip title="Individuals Only">
                    <PersonOutlined />
                  </Tooltip>
                </ToggleButton>
                <ToggleButton value="organization">
                  <Tooltip title="Organizations Only">
                    <CorporateFareOutlined />
                  </Tooltip>
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid> */}
            {/* <Grid
              item
              sx={{ textAlign: 'right' }}
            >
              <TextField
                variant="outlined"
                fullWidth
                // size="small"
                placeholder="Search Contacts"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={event => setSearch((event?.target as any)?.value)}
                sx={{ maxWidth: { xs: 'none', sm: 340 } }}
              />
            </Grid> */}
          </Grid>
        </Grid>

        {/* {exportResult.isLoading ? (
              <CircularProgress size={16} />
            ) : (
              <IconButton
                onClick={() => {
                  exportData({
                    params: {
                      team: team?.id,
                      individual: individual?.id,
                    },
                  });
                }}
                sx={{ ml: 2 }}
                size="large"
              >
                <CloudDownload />
              </IconButton>
            )} */}
      </Grid>
      <TabIndexTable
        config={useMemo(
          () => contactRecord?.form?.factor || ({ tabs: null } as any),
          [contactRecord?.form?.factor]
        )}
        onConfigChange={useCallback(
          async (config: any) => {
            await patchContact({
              id: contactRecord.id,
              form: { factor: { ...config } },
            } as Contact);
          },
          [contactRecord.id]
        )}
        configLoading={patchContactResult.isLoading}
        initialTab={0}
        tables={useMemo(
          () => [
            {
              title: 'Internal Team',
              key: `role-all`,
              visible: true,
              ...tableprops,
              rows:
                [
                  ...(factors.contact || []),
                  // ...(factors.organization || []),
                ].map((v: any) => ({
                  name: {
                    text: v?.organization_r
                      ? v.organization_r?.name
                      : `${v?.contact_r?.firstname} ${v?.contact_r?.lastname}`,
                  },
                  role: {
                    text: v.role_r?.name,
                    sort: [v.role_r?.name],
                  },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text: v.revenue_sum
                      ? `$${numFormatter(v.revenue_sum)}`
                      : undefined,
                    sort: v.revenue_sum,
                  },
                  avg: {
                    text:
                      v.num_projects > 0 && v.revenue_sum
                        ? `$${numFormatter(
                            Math.round(v.revenue_sum / v.num_rev_projects)
                          )}`
                        : undefined,
                    sort: v.revenue_sum / v.num_rev_projects,
                  },
                  win_rate: {
                    text:
                      v.num_projects > 0
                        ? numToPercent(v.num_won_projects / v.num_projects)
                        : undefined,
                    sort:
                      v.num_projects > 0
                        ? v.num_won_projects / v.num_projects
                        : 0,
                  },
                  avg_won_margin: {
                    text:
                      v.avg_won_margin > 0
                        ? formatPercent(v.avg_won_margin)
                        : undefined,
                    sort: v.avg_won_margin > 0 ? v.avg_won_margin : 0,
                  },
                  avg_lost_margin: {
                    text:
                      v.avg_lost_margin > 0
                        ? formatPercent(v.avg_lost_margin)
                        : undefined,
                    sort: v.avg_lost_margin > 0 ? v.avg_lost_margin : 0,
                  },
                })) || ([] as RowCell[]),
            },
            // ...roles
            //   ?.filter(r => !r.subscription && r.type === 'External')
            //   ?.map(s => ({
            //     title: s.name,
            //     key: `role-${s.id}`,
            //     visible: true,
            //     ...tableprops,
            //     rows:
            //       factors.role
            //         ?.filter((r: any) => r.organization)
            //         ?.filter((r: any) => r.role === s.id)
            //         .map((v: any) => ({
            //           name: {
            //             text: v?.organization_r
            //               ? v.organization_r?.name
            //               : `${v?.contact_r?.firstname} ${v?.contact_r?.lastname}`,
            //           },
            //           num: { text: v.num_projects, sort: v.num_projects },
            //           rev: {
            //             text: v.revenue_sum
            //               ? `$${numFormatter(v.revenue_sum)}`
            //               : undefined,
            //             sort: v.revenue_sum,
            //           },
            //           avg: {
            //             text:
            //               v.num_projects > 0 && v.revenue_sum
            //                 ? `$${numFormatter(
            //                     Math.round(v.revenue_sum / v.num_rev_projects)
            //                   )}`
            //                 : undefined,
            //             sort: v.revenue_sum / v.num_rev_projects,
            //           },
            //           win_rate: {
            //             text:
            //               v.num_projects > 0
            //                 ? numToPercent(v.num_won_projects / v.num_projects)
            //                 : undefined,
            //             sort:
            //               v.num_projects > 0
            //                 ? v.num_won_projects / v.num_projects
            //                 : 0,
            //           },
            //           avg_won_margin: {
            //             text:
            //               v.avg_won_margin > 0
            //                 ? formatPercent(v.avg_won_margin)
            //                 : undefined,
            //             sort: v.avg_won_margin > 0 ? v.avg_won_margin : 0,
            //           },
            //           avg_lost_margin: {
            //             text:
            //               v.avg_lost_margin > 0
            //                 ? formatPercent(v.avg_lost_margin)
            //                 : undefined,
            //             sort: v.avg_lost_margin > 0 ? v.avg_lost_margin : 0,
            //           },
            //         })) || ([] as RowCell[]),
            //   })),
            {
              title: 'Competitors',
              key: `competitors`,
              visible: true,
              ...tableprops,
              headCells: [
                {
                  name: 'name',
                  label: 'Name',
                  textFilter: 'name.text',
                  sort: 'name.text',
                  component: ColorTypographyCell,
                },
                {
                  name: 'role',
                  label: 'Role',
                  checkboxFilter: 'role.text',
                  sort: 'role.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'num',
                  label: '# of Projects Won',
                  sort: 'num.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'rev',
                  label: '$ Amount Won',
                  sort: 'rev.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'avg',
                  label: 'Average Price',
                  sort: 'avg.sort',
                  component: ColorTypographyCell,
                },
                {
                  name: 'avg_won_margin',
                  label: 'Avg Won Margin',
                  sort: 'avg_won_margin.sort',
                  component: ColorTypographyCell,
                },
                // ...tableprops.headCells.filter(
                //   (c: any) => !['win_rate', 'avg_lost_margin'].includes(c.name)
                // ),
              ],
              rows:
                factors.workflow
                  ?.filter(
                    (r: any) => r.project_workflow_r?.type === 'competitor'
                  )
                  .map((v: any) => ({
                    name: {
                      text: v?.organization_r
                        ? v.organization_r?.name
                        : `${v?.contact_r?.firstname} ${v?.contact_r?.lastname}`,
                    },
                    role: {
                      text: v.role_r?.name,
                      sort: [v.role_r?.name],
                    },
                    num: { text: v.num_projects, sort: v.num_projects },
                    rev: {
                      text: v.revenue_sum
                        ? `$${numFormatter(v.revenue_sum)}`
                        : undefined,
                      sort: v.revenue_sum,
                    },
                    avg: {
                      text:
                        v.num_projects > 0 && v.revenue_sum
                          ? `$${numFormatter(
                              Math.round(v.revenue_sum / v.num_rev_projects)
                            )}`
                          : undefined,
                      sort: v.revenue_sum / v.num_rev_projects,
                    },
                    win_rate: {
                      text:
                        v.num_projects > 0
                          ? numToPercent(v.num_won_projects / v.num_projects)
                          : undefined,
                      sort:
                        v.num_projects > 0
                          ? v.num_won_projects / v.num_projects
                          : 0,
                    },
                    avg_won_margin: {
                      text:
                        v.avg_won_margin > 0
                          ? formatPercent(v.avg_won_margin)
                          : undefined,
                      sort: v.avg_won_margin > 0 ? v.avg_won_margin : 0,
                    },
                    avg_lost_margin: {
                      text:
                        v.avg_lost_margin > 0
                          ? formatPercent(v.avg_lost_margin)
                          : undefined,
                      sort: v.avg_lost_margin > 0 ? v.avg_lost_margin : 0,
                    },
                  })) || ([] as RowCell[]),
            },
            {
              title: 'Awarding Stakeholders',
              key: `awarding`,
              visible: true,
              ...tableprops,
              rows:
                factors.workflow
                  ?.filter(
                    (r: any) =>
                      r.project_workflow_r?.type === 'awarding' ||
                      !r.project_workflow_r?.type ||
                      r.project_workflow_r?.type === ''
                  )
                  .map((v: any) => ({
                    name: {
                      text: v?.organization_r
                        ? v.organization_r?.name
                        : `${v?.contact_r?.firstname} ${v?.contact_r?.lastname}`,
                    },
                    role: {
                      text: v.role_r?.name,
                      sort: [v.role_r?.name],
                    },
                    num: { text: v.num_projects, sort: v.num_projects },
                    rev: {
                      text: v.revenue_sum
                        ? `$${numFormatter(v.revenue_sum)}`
                        : undefined,
                      sort: v.revenue_sum,
                    },
                    avg: {
                      text:
                        v.num_projects > 0 && v.revenue_sum
                          ? `$${numFormatter(
                              Math.round(v.revenue_sum / v.num_rev_projects)
                            )}`
                          : undefined,
                      sort: v.revenue_sum / v.num_rev_projects,
                    },
                    win_rate: {
                      text:
                        v.num_projects > 0
                          ? numToPercent(v.num_won_projects / v.num_projects)
                          : undefined,
                      sort:
                        v.num_projects > 0
                          ? v.num_won_projects / v.num_projects
                          : 0,
                    },
                    avg_won_margin: {
                      text:
                        v.avg_won_margin > 0
                          ? formatPercent(v.avg_won_margin)
                          : undefined,
                      sort: v.avg_won_margin > 0 ? v.avg_won_margin : 0,
                    },
                    avg_lost_margin: {
                      text:
                        v.avg_lost_margin > 0
                          ? formatPercent(v.avg_lost_margin)
                          : undefined,
                      sort: v.avg_lost_margin > 0 ? v.avg_lost_margin : 0,
                    },
                  })) || ([] as RowCell[]),
            },
            {
              title: 'Market Segment',
              key: `market-segment`,
              visible: true,
              ...tableprops,
              headCells: [
                ...tableprops.headCells.filter((h: any) => h.name !== 'role'),
              ],
              rows:
                [
                  ...(factors.market_segment || []),
                  // ...(factors.organization || []),
                ].map((v: any) => ({
                  name: {
                    text: `${v?.project_type_r?.name} - ${v?.market_segment_r?.name}`,
                  },
                  num: { text: v.num_projects, sort: v.num_projects },
                  rev: {
                    text: v.revenue_sum
                      ? `$${numFormatter(v.revenue_sum)}`
                      : undefined,
                    sort: v.revenue_sum,
                  },
                  avg: {
                    text:
                      v.num_projects > 0 && v.revenue_sum
                        ? `$${numFormatter(
                            Math.round(v.revenue_sum / v.num_rev_projects)
                          )}`
                        : undefined,
                    sort: v.revenue_sum / v.num_rev_projects,
                  },
                  win_rate: {
                    text:
                      v.num_projects > 0
                        ? numToPercent(v.num_won_projects / v.num_projects)
                        : undefined,
                    sort:
                      v.num_projects > 0
                        ? v.num_won_projects / v.num_projects
                        : 0,
                  },
                  avg_won_margin: {
                    text:
                      v.avg_won_margin > 0
                        ? formatPercent(v.avg_won_margin)
                        : undefined,
                    sort: v.avg_won_margin > 0 ? v.avg_won_margin : 0,
                  },
                  avg_lost_margin: {
                    text:
                      v.avg_lost_margin > 0
                        ? formatPercent(v.avg_lost_margin)
                        : undefined,
                    sort: v.avg_lost_margin > 0 ? v.avg_lost_margin : 0,
                  },
                })) || ([] as RowCell[]),
            },
          ],
          [roles, tableprops, factors]
        )}
      />
    </Paper>
  );
};
